import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { useSwitchWorkspaceMutation } from "@/hooks/useBackendData";
import { useAppStore } from "@/state/appStore";

export const WorkspaceSwitcher = (): JSX.Element => {
  const workspace = useAppStore((state) => state.workspace);
  const switchWorkspaceMutation = useSwitchWorkspaceMutation();
  const workspacesQuery = useQuery({
    queryKey: ["api", "workspace-list"],
    queryFn: apiClient.getWorkspaces,
    staleTime: 30_000,
    refetchOnWindowFocus: false
  });

  const workspaces = workspacesQuery.data ?? [];

  if (workspaces.length <= 1) {
    return (
      <span className="inline-flex max-w-[180px] items-center rounded-full border border-[var(--border-default)] bg-[var(--bg-tertiary)] px-2 py-1 text-xs text-[var(--text-secondary)]">
        {workspace.name}
      </span>
    );
  }

  return (
    <label className="inline-flex max-w-[180px] items-center rounded-full border border-[var(--border-default)] bg-[var(--bg-tertiary)] px-2 py-1 text-xs text-[var(--text-secondary)]">
      <select
        className="max-w-[160px] bg-transparent text-xs text-[var(--text-secondary)]"
        value={workspace.id}
        disabled={switchWorkspaceMutation.isPending}
        onChange={(event) => {
          const next = event.target.value;
          if (!next || next === workspace.id) return;
          void switchWorkspaceMutation.mutateAsync(next);
        }}
      >
        {workspaces.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </label>
  );
};
